"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.WIZARD_TYPE = exports.WIZARD_SIZE = void 0;
require("react");
require("rxjs");
require("@veeam/components");
require("./WizardApiController");
var components_1 = require("@veeam/components");
Object.defineProperty(exports, "WIZARD_SIZE", { enumerable: true, get: function () { return components_1.DIALOG_SIZE; } });
var WIZARD_TYPE;
(function (WIZARD_TYPE) {
    WIZARD_TYPE["dialog"] = "dialog";
    WIZARD_TYPE["page"] = "page";
})(WIZARD_TYPE = exports.WIZARD_TYPE || (exports.WIZARD_TYPE = {}));
//# sourceMappingURL=types.js.map